import React, { ReactNode, useEffect, useState } from 'react';
import clsx from 'clsx';
import { Button } from 'shared/components/Button';
import { Icon } from 'shared/components/Icon';
import { useLocalStorage } from 'shared/utils/local-storage';
import './style.less';

interface ToggleCardProps {
  ulsKey: string;
  header: ReactNode;
  callback?: (isOpen: boolean) => void;
  isDefaultOpen?: boolean;
  forceOpen?: boolean;
}

export const ToggleCard: React.FC<ToggleCardProps> = ({
  ulsKey,
  header,
  callback,
  isDefaultOpen = true,
  children,
  forceOpen,
}) => {
  const [isOpen, setIsOpen] = useLocalStorage({
    key: `ToggleCard:${ulsKey}`,
    initialState: isDefaultOpen,
  });

  const [isForceOpen, setIsForceOpen] = useState(!!forceOpen);

  useEffect(() => {
    if (callback) {
      callback(!forceOpen ? isOpen : isForceOpen);
    }
  }, [callback, isOpen, isForceOpen, forceOpen]);

  useEffect(() => {
    if (forceOpen !== undefined) {
      setIsForceOpen(forceOpen);
    }
  }, [forceOpen]);

  return (
    <div className="ToggleCard">
      <Button
        type="ghost"
        className="ToggleCard__header"
        onClick={() => {
          if (forceOpen) {
            setIsForceOpen(!isForceOpen);
          } else {
            setIsOpen(!isOpen);
          }
        }}
      >
        <div className="ToggleCard__header-label">{header}</div>
        <Icon
          className={clsx(
            'ToggleCard__header-toggle',

            (!forceOpen ? isOpen : isForceOpen) && 'ToggleCard__header-toggle--open',
          )}
          icon="down"
        />
      </Button>
      {(!forceOpen ? isOpen : isForceOpen) && (
        <div className="ToggleCard__content">{children}</div>
      )}
    </div>
  );
};
